import { Form, InputGroup } from 'react-bootstrap';
import { MAX_NUMBER } from '../../../constants/constants';
import { useState } from 'react';
import Required from '../../../utils/Required';
import { useFormValidated } from '../common/FormValidationContext';
import { useAccessibleId } from '../common/hooks/useAccessibleId';

/**
 * For fields like Household Size and TPA Months that require integer values,
 * we want to round any decimal inputs on blur and have no currency or
 * percentage formatting symbols.
 */
const NumericalField = ({ value, min, max, fieldName, onChange, disabled, isSubmitting }) => {
  // set defaults
  min = min ?? 0;
  max = max ?? MAX_NUMBER;
  
  const [touched, setTouched] = useState(false);
  const validated = useFormValidated();
  const fieldNameDisplay = fieldName ?? 'Numerical Data';
  const controlId = useAccessibleId(fieldNameDisplay);
  
  const getErrorMessage = () => {
    if (!value || value === '') return `${fieldNameDisplay} is required.`;
    if (value > max || value < min) return `${fieldNameDisplay} must be between ${min} and ${max}.`;
    return null;
  };

  const handleBlur = () => {
    setTouched(true);

    if (value !== '' && value !== null && value !== undefined) {
      const rounded = Math.floor(value);
      onChange(rounded);
    }
  };

  const errorMessage = getErrorMessage();
  const isInvalid = (touched || validated) && !!errorMessage;

  return (
  <Form.Group>
    <InputGroup hasValidation>
      <Form.FloatingLabel label={<Required>{fieldNameDisplay}</Required>} controlId={controlId}>
        <Form.Control
          type="number"
          min={min}
          max={max}
          required
          value={value}
          onChange={e => onChange(e.target.value)}
          onBlur={handleBlur}
          onWheel={(e) => e.target.blur()}
          disabled={disabled || isSubmitting}
          isInvalid={!!errorMessage && touched}
          placeholder=""
        />
        <Form.Control.Feedback type="invalid"
          className={isInvalid ? 'd-block' : undefined}>
          {errorMessage}
        </Form.Control.Feedback>
      </Form.FloatingLabel>
    </InputGroup>
  </Form.Group>
)};

export default NumericalField;